import { render } from "./MuralView.vue?vue&type=template&id=22af9fec"
import script from "./MuralView.vue?vue&type=script&lang=js"
export * from "./MuralView.vue?vue&type=script&lang=js"

import "./MuralView.vue?vue&type=style&index=0&id=22af9fec&lang=css"

import exportComponent from "/Users/romuloreis/Documents/CakeCherries/mural-viewer-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__